import React from 'react';
import { Form, Field } from 'react-final-form';
import { OnChange } from 'react-final-form-listeners'
import { Col, Row, Label, Alert } from 'reactstrap';
import PropTypes from 'prop-types';
// import { LinkContainer } from 'react-router-bootstrap';

// Local Deps
import './UserForm.scss';
import msgs from '../../../config/messages';
import formConfig from './formConfig';
import NFButton from '../../primitives/NFButton';
// import { accountAdminRoute, superAdminHomeRoute } from '../../../config/navigation/routes';
// import history from '../../../config/history';

import { required } from '../../../utils/validationUtils';

function UserForm({
  onSubmit,
  onChangeRole,
  onChangeField,
  initialValues,
  iconStatusIsHidden,
  alertMessage,
  alertType,
  onCancelUserForm,
  auth
}) {
  return (
    <div className="nf-tooling-def-form">
      <Form
        onSubmit={onSubmit}
        initialValues={initialValues}
        render={({
          handleSubmit,
          // pristine,
          invalid,
          submitting,
          validating,
        }) => (
          <form className="nf-user-form" onSubmit={handleSubmit}>
            {alertMessage && <Alert color={alertType}>{alertMessage}</Alert>}
            {/* <Alert style={{ height: '50px' }} color="success">
              Something happened
            </Alert> */}
            <div>
              {/* <!-- CONFIGURED FIELDS --> */}

              {formConfig.map((fieldConfig) => (
                <Field
                  key={fieldConfig.name} {...fieldConfig}
                  disabled={fieldConfig.name === 'email' && initialValues.id}
                />
              ))}

              {formConfig.map((fieldConfig) => (
                <OnChange key={fieldConfig.name} name={fieldConfig.name}>
                  {(value) => {
                    onChangeField(value, fieldConfig.name)
                  }}
                </OnChange>
              ))}

              {/* <!-- SELECT FIELDS --> */}
              {!iconStatusIsHidden && (
                <Field name="iconStatus" validate={required}>
                  {({ input, meta }) => (
                    <div className="nf-rff-input-field">
                      <Row className="nf-rff-input-field__row">
                        <Col md={3} style={{ display: 'flex' }}>
                          <Label className="nf-rff-input-field__label" htmlFor={input.name}>
                            {msgs.AddUser.iconStatus}
                            <span className="nf-rff-input-field__required">*</span>
                          </Label>
                        </Col>
                        <Col md={6}>
                          <select className="nf-rff-input-field__input" {...input}>
                            <option value="approved">
                              {msgs.AddUser.approved}
                            </option>
                            <option value="blocked">
                              {msgs.AddUser.blocked}
                            </option>
                          </select>
                          {meta.touched && meta.error && (
                            <div className="nf-rff-input-field__error" style={{ marginTop: 4 }}>
                              {meta.error}
                            </div>
                          )}
                        </Col>
                      </Row>
                    </div>
                  )}
                </Field>
              )}

              {auth.role === 'SUPER_ADMIN' && (
                <div>
                  <Field name="role">
                    {({ input, meta }) => (
                      <div className="nf-rff-input-field">
                        <Row className="nf-rff-input-field__row">
                          <Col md={3} style={{ display: 'flex' }}>
                            <Label className="nf-rff-input-field__label" htmlFor={input.name}>
                              Role
                              <span className="nf-rff-input-field__required">*</span>
                            </Label>
                          </Col>
                          <Col md={6}>
                            <select className="nf-rff-input-field__input" {...input}>
                              <option value="user">
                                {msgs.AddUser.accountUser}
                              </option>
                              <option value="admin">
                                {msgs.AddUser.accountAdmin}
                              </option>
                              <option value="super">
                                {msgs.AddUser.accountSuper}
                              </option>
                            </select>
                            {meta.touched && meta.error && (
                              <div className="nf-rff-input-field__error" style={{ marginTop: 4 }}>
                                {meta.error}
                              </div>
                            )}
                          </Col>
                        </Row>
                      </div>
                    )}
                  </Field>
                  <OnChange name="role">
                    {(value) => {
                      onChangeRole(value)
                    }}
                  </OnChange>
                </div>

              )}
              {auth.role !== 'SUPER_ADMIN' && (
                <div>
                  <Field name="role">
                    {({ input, meta }) => (
                      <div className="nf-rff-input-field">
                        <Row className="nf-rff-input-field__row">
                          <Col md={3} style={{ display: 'flex' }}>
                            <Label className="nf-rff-input-field__label" htmlFor={input.name}>
                              Role
                              <span className="nf-rff-input-field__required">*</span>
                            </Label>
                          </Col>
                          <Col md={6}>
                            <select className="nf-rff-input-field__input" {...input}>
                              <option value="user">
                                {msgs.AddUser.accountUser}
                              </option>
                              <option value="admin">
                                {msgs.AddUser.accountAdmin}
                              </option>
                            </select>
                            {meta.touched && meta.error && (
                              <div className="nf-rff-input-field__error" style={{ marginTop: 4 }}>
                                {meta.error}
                              </div>
                            )}
                          </Col>
                        </Row>
                      </div>
                    )}
                  </Field>
                  <OnChange name="role">
                    {(value) => {
                      onChangeRole(value)
                    }}
                  </OnChange>
                </div>
              )}
              <Row>
                <Col sm={{ size: 7, offset: 2 }} className="text-center">
                  {/* {auth.role === 'SUPER_ADMIN' && (
                    <LinkContainer to={superAdminHomeRoute.replace(':page', 'searchUsers')}>
                      <NFButton className="nf-button--gray-border">
                        To SuperAdmin
                      </NFButton>
                    </LinkContainer>
                  )} */}
                  {/* <LinkContainer to={accountAdminRoute}>
                    <NFButton className="nf-button--gray-border">
                      {msgs.Form.cancelButton}
                    </NFButton>
                  </LinkContainer> */}
                  <NFButton
                    className="nf-button--gray-border"
                    onClick={() => {
                      onCancelUserForm();
                    }}
                  >
                    {msgs.Form.cancelButton}
                  </NFButton>
                  <NFButton
                    className="nf-button--form nf-button--orange"
                    type="submit"
                    disabled={invalid || submitting || validating}
                  >
                    {msgs.Form.submitButton}
                  </NFButton>
                </Col>
              </Row>
            </div>
          </form>
        )}
      />
    </div >
  );
}

UserForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onChangeRole: PropTypes.func.isRequired,
  onChangeField: PropTypes.func.isRequired,
  initialValues: PropTypes.shape({
    id: PropTypes.string,
    fullName: PropTypes.string,
    email: PropTypes.string,
    phoneNumber: PropTypes.string,
    faxNumber: PropTypes.string,
    iconStatus: PropTypes.string,
    role: PropTypes.string,
  }),
  auth: PropTypes.shape({
    jwtToken: PropTypes.string,
    expiration: PropTypes.number,
    organizationId: PropTypes.string,
    role: PropTypes.string,
  }).isRequired,
  iconStatusIsHidden: PropTypes.bool,
  alertType: PropTypes.string.isRequired,
  alertMessage: PropTypes.string.isRequired,
  onCancelUserForm: PropTypes.func.isRequired,
};

UserForm.defaultProps = {
  iconStatusIsHidden: false,
  initialValues: {},
};

export default UserForm;



// WEBPACK FOOTER //
// ./src/components/forms/UserForm/UserForm.jsx